// /var/www/afra/192.testproject.work/maracar8/0.8.2/myapp/src/components/DataQueues/EventDialogServiceTimeSidebar/PaymentDetails.js

import { useState, useEffect } from 'react';
import { InputText } from 'primereact/inputtext';
import { QRCodeCanvas } from 'qrcode.react';

import { getSelectedLanguage } from '../../../api/api';
import { languageManager } from '../../../utils/loadLanguage';



const PaymentDetails = ({ paymentMethodGroup1, paymentDetails }) => {


    const [translations, setTranslations] = useState({});

    useEffect(() => {
        async function loadLang() {
            const lang = getSelectedLanguage();
            await languageManager.loadLanguage(lang);
            setTranslations(languageManager.translations);

        }
        loadLang();
    }, []);

    if (paymentMethodGroup1 === 'visa') {
        return (
            <div className="credit-card-inputs">
                <InputText placeholder="Card Number" style={{ width: '100%' }} />
                <InputText placeholder="Expiration Month" style={{ width: '100%' }} />
                <InputText placeholder="Expiration Year" style={{ width: '100%' }} />
                <InputText placeholder="CVC" style={{ width: '100%' }} />
            </div>
        );
    } else if (paymentMethodGroup1 === 'payCash') {
        return (
            <div className="bank-details">
                <p>{paymentDetails.details.bankName}</p>
                

                <p>{translations.paymentDetails?.label_number || "Number"}: {paymentDetails.details.accountNumber}</p>
                <p>{translations.paymentDetails?.label_iban || "IBAN"}: {paymentDetails.details.iban}</p>
                <p>{translations.paymentDetails?.label_swift || "SWIFT"}: {paymentDetails.details.swift}</p>

            </div>
        );
    } else if (paymentMethodGroup1 === 'qrCode') {
        return (
            <div className="qr-code">
                <QRCodeCanvas value={paymentDetails.details.accountNumber} style={{ display: 'block', margin: '0 auto' }} />
                <p>{paymentDetails.details.bankName}</p>
                <p>{translations.paymentDetails?.label_number || "Number"}: {paymentDetails.details.accountNumber}</p>
                <p>{translations.paymentDetails?.label_iban || "IBAN"}:: {paymentDetails.details.iban}</p>
                <p>{translations.paymentDetails?.label_swift || "SWIFT"}:: {paymentDetails.details.swift}</p>
            </div>
        );
    }
    return null;
};

export default PaymentDetails;
